import { Navigate, useParams } from 'react-router'

/** Old email links used `/dashboard/vaults/:id`. */
export function LegacyVaultDetailRedirect() {
  const { id } = useParams<{ id: string }>()
  if (!id) return <Navigate to="/dashboard" replace />
  return <Navigate to={`/dashboard/vault/${id}`} replace />
}
